





















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'


import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import DigitalCurrency1DigitalCurrencySymbol from './digital-currency-1-digital-currency-symbol.vue'
import DigitalCurrency20AnimatedCurrencyLabel from './digital-currency-20-animated-currency-label.vue'

// import { algorithm as getFormattedNumber } from '../../../../../../../algorithms/get-formatted-number'
import { getDigitalCurrencyAmountWithCommaSeparatedValue } from './service-for-helper-algorithms/helper-algorithms-2-get-digital-currency-amount-with-comma-separated-value'

@Component({
  components: {
    DigitalCurrency1DigitalCurrencySymbol,
    DigitalCurrency20AnimatedCurrencyLabel
  }
})
class DigitalCurrency4PriceLabel extends Vue {
  @Prop({ default: true }) doesShowDigitalCurrencyIcon?: boolean
  @Prop({ default: 24 }) digitalCurrencyIconSize?: number
  @Prop({ default: 0 }) digitalCurrencyAmount?: number
  @Prop({ default: '' }) accountId?: string
  @Prop({ default: true }) isDigitalCurrencyAmountConvertedToDecimalNumber?: boolean
  @Prop({ default: 'initial' }) fontSize?: string
  @Prop({ default: '10px' }) marginRight?: string
  @Prop({ default: true }) showIncrementDecrementAnimation?: boolean
  @Prop({ default: true }) showVerticalIncrementDecrementAnimation?: boolean
  @Prop({ default: true }) showIncrementDecrementAnimationSinceTimeUpdate?: boolean
  @Prop({ default: false }) showIncrementDecrementAnimationNumberOfTransactions?: boolean
  @Prop({ default: false }) showIncrementDecrementAnimationTransactionTextAbbreviated?: boolean

  digitalCurrencyName: string = projectVariables.digitalCurrencyName

  getDigitalCurrencyAmountWithCommaSeparatedValue = getDigitalCurrencyAmountWithCommaSeparatedValue
}

export default DigitalCurrency4PriceLabel

